import { render } from "./OrderAddCut.vue?vue&type=template&id=c83cf9e0&scoped=true"
import script from "./OrderAddCut.vue?vue&type=script&lang=js"
export * from "./OrderAddCut.vue?vue&type=script&lang=js"

import "./OrderAddCut.vue?vue&type=style&index=0&id=c83cf9e0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\caleb\\OneDrive\\Desktop\\apps\\kff_ordering_portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c83cf9e0"]])

export default __exports__